module.exports = __webpack_public_path__ + "img/2_no.42891fb1.svg";